import type * as mapboxgl from 'mapbox-gl'
import { MapStyleType } from '../enums/map-style-type.enum'

/**
 * Custom Mapbox control for switching between map styles
 */
export class MapStyleControl implements mapboxgl.IControl {
  private _map?: mapboxgl.Map
  // Created by `onAdd`, which Mapbox calls synchronously from `map.addControl`
  private _container!: HTMLDivElement
  private _button!: HTMLButtonElement
  private _currentStyle: MapStyleType
  private _onToggle: () => void

  constructor(onToggle: () => void, initialStyle: MapStyleType = 'standard') {
    this._onToggle = onToggle
    this._currentStyle = initialStyle
  }

  onAdd(map: mapboxgl.Map): HTMLElement {
    this._map = map
    this._container = document.createElement('div')
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group'

    this._button = document.createElement('button')
    this._button.className = 'mapboxgl-ctrl-icon'
    this._button.type = 'button'
    this._button.setAttribute('aria-label', 'Toggle map style')
    this._button.style.display = 'flex'
    this._button.style.alignItems = 'center'
    this._button.style.justifyContent = 'center'

    // Set initial icon based on current style
    const icon = this._currentStyle === 'standard' ? 'pi-globe' : 'pi-map'
    this._button.innerHTML = `<i class="pi ${icon}" style="font-size: 18px;"></i>`

    // The icon is driven by `setStyle` (called by MapCoreService.setMapStyle), so
    // programmatic and user-triggered style changes stay in sync
    this._button.addEventListener('click', () => this._onToggle())

    this._container.appendChild(this._button)
    return this._container
  }

  onRemove(): void {
    if (this._container && this._container.parentNode) {
      this._container.parentNode.removeChild(this._container)
    }
    this._map = undefined
  }

  setStyle(style: MapStyleType): void {
    this._currentStyle = style
    const icon = style === 'standard' ? 'pi-globe' : 'pi-map'
    this._button.innerHTML = `<i class="pi ${icon}" style="font-size: 18px;"></i>`
  }
}
